import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Input, Menu, Dropdown, Modal, Confirm } from 'semantic-ui-react';
import { showLoading, hideLoading, showMessage, hideMessage, getProducts, openVoucherModal } from '../actions';

class VouchersMenu extends Component {
    handleCreateVoucher = (e) => {
        this.props.openVoucherModal(true);
    }

    render() {

        return (
            <Fragment>
                <Menu fixed='left' vertical style={{ marginTop: '5em', marginLeft: '0em' }}>
                    <Menu.Item name='add' onClick={this.handleCreateVoucher.bind(this)}>
                        <Icon name='ticket' />
                        Create New Voucher
                    </Menu.Item>
                </Menu>
            </Fragment>
        )
    }
}
const mapStateToProps = ({voucher}) => {
    return { voucher }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        openVoucherModal: openVoucherModal
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(VouchersMenu);